// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_87-4";
export var collapsed = "_87-1";
export var headerBar = "_87-0";
export var leftHeaderContent = "_87-3";
export var subjectContainer = "_87-2";